import { TabList } from '../../../Tab'

import { getStatisticTabs } from './StatisticTabs.utils'

import * as styles from './StatisticTabs.module.css'

function StatisticTabs({ activeTab, onSetActiveTab }) {
  return (
    <TabList
      activeTab={activeTab}
      getTabs={getStatisticTabs}
      tabProps={{
        className: styles.tab,
      }}
      onSetActiveTab={onSetActiveTab}
    />
  )
}

export default StatisticTabs
